export const isLocalStorageSupported = () => {
  let testKey = "test"
  let storage = window.localStorage
  try {
    storage.setItem(testKey, "1")
    storage.removeItem(testKey)
    return true
  } catch (error) {
    return false
  }
}

export const isCookieSupported = () => {
  let cookieEnabled = navigator.cookieEnabled ? true : false

  if (!cookieEnabled) {
    document.cookie = "testCookie"
    cookieEnabled = document.cookie.indexOf("testCookie") !== -1 ? true : false
  }
  return cookieEnabled
}

export class ObjectCompare {
  constructor() {
    this.VALUE_CREATED = "created"
    this.VALUE_UPDATED = "updated"
    this.VALUE_DELETED = "deleted"
    this.VALUE_UNCHANGED = "unchanged"
  }

  static createNew() {
    return new ObjectCompare()
  }

  getDiff = (obj1, obj2, fillter = false) => {
    if (this.isFunction(obj1) || this.isFunction(obj2)) {
      throw new Error("Invalid argument. Function given, object expected.")
    }
    if (this.isValue(obj1) || this.isValue(obj2)) {
      if (fillter) {
        if (["created", "updated"].includes(this.compareValues(obj1, obj2))) {
          return obj2
        }
        return this.isNumber(obj2) ? -1 : null
      }
      return {
        type: this.compareValues(obj1, obj2),
        data: obj1 === undefined ? obj2 : obj1,
      }
    }

    let diff = {}
    for (let key in obj1) {
      if (this.isFunction(obj1[key])) {
        continue
      }

      let value2 = undefined
      if ("undefined" != typeof obj2[key]) {
        value2 = obj2[key]
      }

      diff[key] = this.getDiff(obj1[key], value2, fillter)
    }
    for (let key in obj2) {
      if (this.isFunction(obj2[key]) || "undefined" != typeof diff[key]) {
        continue
      }

      diff[key] = this.getDiff(undefined, obj2[key], fillter)
    }

    return diff
  }

  compareValues = (value1, value2) => {
    if (value1 === value2) {
      return this.VALUE_UNCHANGED
    }
    if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
      return this.VALUE_UNCHANGED
    }
    if ("undefined" == typeof value1) {
      return this.VALUE_CREATED
    }
    if ("undefined" == typeof value2) {
      return this.VALUE_DELETED
    }

    return this.VALUE_UPDATED
  }

  isFunction = (obj) => {
    return {}.toString.apply(obj) === "[object Function]"
  }

  isArray = (obj) => {
    return {}.toString.apply(obj) === "[object Array]"
  }

  isDate = (obj) => {
    return {}.toString.apply(obj) === "[object Date]"
  }

  isObject = (obj) => {
    return {}.toString.apply(obj) === "[object Object]"
  }

  isNumber = (obj) => {
    return {}.toString.apply(obj) === "[object Number]"
  }

  isValue = (obj) => {
    return !this.isObject(obj) && !this.isArray(obj)
  }
}
